import { Component, ChangeDetectionStrategy, Input } from '@angular/core'

@Component({
  selector: 'empty-white-label-no-queued-submissions',
  template: `
    <div class="text-center mt-3 mb-2 empty-state">
      <i class="fas fa-exclamation-triangle"></i>
      <h4 class="mt-4">
        <strong>Looks like there is no content to review</strong>
      </h4>
      <p class="mt-3">
        Questions? Contact your
        <span *ngIf="agencyName">{{agencyName}}</span>
        account manager for more information
      </p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyWhiteLabelNoQueuedSubmissionsComponent {
  @Input() agencyName: string
}
